import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  NavigationGuardNext,
  RouteLocationNormalized,
} from "vue-router";
import HomeView from "../views/HomeView.vue";
import AuthLogin from "../views/Authentication/SignIn/LoginPage.vue";
import DevicesView from "../views/Devices/DevicesView.vue";
import DeviceView from "@/views/Devices/DeviceView.vue";
import ReportsView from "@/views/Reports/ReportsView.vue";
import CustomersView from "@/views/Companies/CustomersView.vue";
import SettingsView from "@/views/Settings/SettingsView.vue";
import StatusView from "@/views/Status/StatusView.vue";
import CompaniesView from "@/views/Companies/CompaniesView.vue";
import LocationsView from "@/views/Locations/LocationsView.vue";
import TeamsView from "@/views/Teams/TeamsView.vue";
// Importaciones de nuevos módulos de configuración
import MeasurementsView from "@/views/DeviceSamples/DeviceSamplesView.vue";
import FtpSettingsView from "@/views/FtpSettings/FtpSettingsView.vue";
import SerialSettingsView from "@/views/SerialSettings/SerialSettingsView.vue";
import DeviceMeasurementsView from "@/views/DeviceMeasurements/DeviceMeasurementsView.vue";
import DeviceSettingsView from "@/views/DeviceSettings/DeviceSettingsView.vue";
import ManagerDevicesView from "@/views/Devices/ManagerDevicesView.vue";
import SensorsView from "@/views/Sensors/SensorsView.vue";
import SensorGroupsView from "@/views/SensorGroups/SensorGroupsView.vue";
import SensorGroupSensorsView from "@/views/SensorGroupSensors/SensorGroupSensorsView.vue";
import SensorNormalizationsView from "@/views/SensorNormalizations/SensorNormalizationsView.vue";
import DeviceExtractionsView from "@/views/DeviceExtractions/DeviceExtractionsView.vue";
import SensorExtractionsView from "@/views/SensorExtractions/SensorExtractionsView.vue";
import SensorInjectionsView from "@/views/SensorInjections/SensorInjectionsView.vue";
import NetworkLogsView from "@/views/NetworkLogs/NetworkLogsView.vue";
import { auth } from "@/config/firebase";
import { useAuthStore } from "@/views/Authentication/store";

import { CustomRouteMeta } from "./types";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/devices",
    name: "devices",
    component: DevicesView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/devices/:id",
    name: "device",
    component: DeviceView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/reports",
    name: "reports",
    component: ReportsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/status",
    name: "status",
    component: StatusView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/auth/login",
    name: "login",
    component: AuthLogin,
    meta: {
      layout: "auth",
    },
  },
  {
    path: "/customers",
    name: "customers",
    component: CustomersView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/teams",
    name: "teams",
    component: TeamsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/companies",
    name: "companies",
    component: CompaniesView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/locations",
    name: "locations",
    component: LocationsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/device-samples",
    name: "deviceSamples",
    component: MeasurementsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  // Rutas de configuración FTP y protocolos
  {
    path: "/ftp-settings",
    name: "ftp-settings",
    component: FtpSettingsView,
    meta: {
      requireAuth: true,
      role: ["admin"],
    },
  },

  {
    path: "/serial-settings",
    name: "serial-settings",
    component: SerialSettingsView,
    meta: {
      requireAuth: true,
      role: ["admin"],
    },
  },
  // Rutas de gestión de datos de dispositivos
  {
    path: "/device-measurements",
    name: "device-measurements",
    component: DeviceMeasurementsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/device-settings",
    name: "device-settings",
    component: DeviceSettingsView,
    meta: {
      requireAuth: true,
      role: ["admin"],
    },
  },
  {
    path: "/manager-devices",
    name: "manager-devices",
    component: ManagerDevicesView,
    meta: {
      requireAuth: true,
      role: ["admin"],
    },
  },
  // Rutas de gestión de sensores
  {
    path: "/sensors",
    name: "sensors",
    component: SensorsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/sensor-groups",
    name: "sensor-groups",
    component: SensorGroupsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/sensor-group-sensors",
    name: "sensor-group-sensors",
    component: SensorGroupSensorsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/sensor-normalizations",
    name: "sensor-normalizations",
    component: SensorNormalizationsView,
    meta: {
      requireAuth: true,
      role: ["admin"],
    },
  },
  // Rutas de extracción e inyección de datos
  {
    path: "/device-extractions",
    name: "device-extractions",
    component: DeviceExtractionsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/sensor-extractions",
    name: "sensor-extractions",
    component: SensorExtractionsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
  {
    path: "/sensor-injections",
    name: "sensor-injections",
    component: SensorInjectionsView,
    meta: {
      requireAuth: true,
      role: ["admin"],
    },
  },
  // Rutas de monitoreo y logs
  {
    path: "/network-logs",
    name: "network-logs",
    component: NetworkLogsView,
    meta: {
      requireAuth: true,
      role: ["admin", "user"],
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const waitForUserData = async (
  authStore: ReturnType<typeof useAuthStore>
): Promise<void> => {
  return new Promise((resolve) => {
    if (authStore.userProfile && authStore.userProfile.role) {
      resolve();
      return;
    }

    const checkUserData = setInterval(() => {
      if (authStore.userProfile && authStore.userProfile.role) {
        clearInterval(checkUserData);
        resolve();
      }
    }, 100);
  });
};

router.beforeEach(
  async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    const authStore = useAuthStore();
    const user = auth.currentUser;

    if (user) {
      await waitForUserData(authStore);
    }

    if ((to.meta as CustomRouteMeta).requireAuth) {
      if (!user) {
        next({ path: "/auth/login" });
      } else {
        const requiredRole = (to.meta as CustomRouteMeta).role || [];
        if (requiredRole.includes(authStore.userProfile?.role || "")) {
          next();
        } else {
          next({ path: "/unauthorized" });
        }
      }
    } else {
      next();
    }
  }
);

export default router;
